import pencil from 'src/assets/icons/icon-pencil.svg';

interface PencilProps {
  onClick: React.MouseEventHandler<HTMLSpanElement>;
}

export const Pencil: React.FC<PencilProps> = ({ onClick }) => (
  <span className="edit-icon me-4 cursor-pointer" onClick={onClick}>
    <img src={pencil} alt="pencil" />
  </span>
);
